import keywordTrackerApi from '@/app/KeywordTracker/api/keywordTrackerApi';
import type { DomainSlugArg } from '@/app/KeywordTracker/types/keywordTrackerApiTypes';

const groupsApi = keywordTrackerApi.injectEndpoints({
  endpoints: build => ({
    getGroupsForSelect: build.query<unknown, DomainSlugArg>({
      query: domain_slug =>
        `/keyword_tracker/v2/groups/for_select?domainSlug=${domain_slug}`,
      providesTags: ['groupsForSelect']
    })
  })
});

export const { useGetGroupsForSelectQuery } = groupsApi;
export default groupsApi;
